<template>
    <div>
        <Loader :show="loading"></Loader>
        <template v-if="!loading">
            <Banner :banners="banners" show-overlay> </Banner>
            <Breadcrumb></Breadcrumb>
            <div class="info-wrapper default">
                <h2 class="title text-center" v-text="detail.subject">
                    筏子溪科普親子體驗營 泡泡糖╳清潔液DIY樂
                </h2>
                <div class="detail-card green">
                    <div class="card-body">
                        <div class="title mb-2">活動介紹</div>
                        <div class="text-danger">
                            日期：{{
                                dateConvert(detail.startDate, 'YYYY') - 1911
                            }}年{{ dateConvert(detail.startDate, 'MM月DD日') }}
                        </div>
                        <div class="text-danger mb-3">
                            地點：{{ '筏子溪水文化暨環境教育館' }}
                        </div>
                        <vue-load-image
                            class="mb-2"
                            v-for="(photoId, index) in detail.listPhotos"
                            :key="photoId"
                        >
                            <img
                                slot="image"
                                :src="`${apiPhotoUrl}/ori/${photoId}`"
                                :alt="detail.name + index"
                                class="event-img"
                            />
                            <img
                                slot="preloader"
                                src="@/assets/image-loader.gif" class="w-100"
                            />
                            <img
                                slot="error"
                                class="border d-block detail-img"
                                src=""
                                alt="not found"
                            />
                        </vue-load-image>

                        <div
                            class="html-wrapper border-b mb-3"
                            v-html="detail.description"
                        >
                            <p>
                                「筏子溪水文化暨環境教育館」於111年1月5日展出溪流科普藝術展展覽中將呈現東海大學化學系師生團隊的科學藝術作品，如透明魚標本、植物染布、分子料理泡泡糖製作原理
                                、構樹清潔液等，也將透過開設體驗營及工作坊活動，親自讓遊客能夠體驗DIY的樂趣，也進一步了解科學的奧秘
                                。
                            </p>
                            <p style="text-indent:2em">
                                其中像是筏子溪溪畔常見的構樹為早期大肚山梅花鹿的主要食物，因此「構樹」又稱為「鹿仔樹」其中樹皮還能成鈔票。構樹也富含有蛋白質胜肽，也將開立工作坊除了帶領大小朋友到溪畔認識植物從植物教學中了解什麼種類可以製成清潔液回到館內進行DIY體驗樂趣同樣化學變化由東海大學大學院競賽中脫穎而出的分子料理製作學生團隊關心食安，用安全的化學科普原理變成一顆顆透亮可食用的泡泡糖
                                .
                                也將帶著親子親手做出屬於自己的寒天蒟蒻，帶著大小朋友了解透過乳化作用、晶球化反應、液態氮、低溫烹調等技術，可以DIY
                                做出屬於自己口味的泡泡糖。
                            </p>
                        </div>
                        <div class="title">活動名稱</div>
                        <div
                            class="text-sm mb-2"
                            style="text-indent:1em"
                            v-text="detail.subject"
                        >
                            筏子溪科普親子體驗營 泡泡糖╳清潔液DIY樂
                        </div>
                        <div class="title">活動類型</div>
                        <div
                            class="text-sm mb-2"
                            style="text-indent:1em"
                            v-text="detail.eventType"
                        >
                            教育研習
                        </div>
                        <div class="title">活動起日-迄日</div>
                        <div
                            class="text-sm border-b pb-3"
                            style="text-indent:1em"
                        >
                            {{ dateConvert(detail.startDate, 'YYYY-MM-DD') }} 至
                            {{ dateConvert(detail.endDate, 'YYYY-MM-DD') }}
                        </div>
                        <button
                            class="btn btn-more w-100 d-block my-3"
                            @click="goGoogleMap([detail.lon, detail.lat])"
                        >
                            前往活動地點
                        </button>
                        <button
                            class="btn btn-more w-100 d-block my-3"
                            @click="
                                addGoogleCalendar(
                                    detail.subject,
                                    detail.startDate,
                                    detail.endDate,
                                )
                            "
                        >
                            加入Google行事曆
                        </button>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
/* eslint-disable global-require */
import { mapActions } from 'vuex';
import Banner from '@/components/shared/Banner';
import Breadcrumb from '@/components/Breadcrumb';
import coreMixin from '@/js/mixin/coreMixin';
import Loader from '@/components/Loader';
import { apiEventDetail } from '@/plugin/api';

export default {
    data() {
        return {
            banners: [
                {
                    linkUrl: require('@/assets/event_detail_img.jpg'),
                },
            ],
            loading: false,
            detail: {},
        };
    },
    created() {},
    mounted() {
        this.getDetail();
    },
    methods: {
        ...mapActions('userData', ['setSpotPosition']),
        async getDetail() {
            const { id } = this.$route.params;
            this.loading = true;
            await apiEventDetail(id).then((res) => {
                if (res.data.success) {
                    this.detail = {
                        ...res.data.data,
                        lat: +res.data.data.latitude,
                        lon: +res.data.data.longitude,
                        name: res.data.data.subject,
                        id: res.data.data.eventId,
                    };
                    this.setSpotPosition([this.detail.lon, this.detail.lat]);
                    const { breadcrumb } = this.$route.meta;
                    breadcrumb[
                        breadcrumb.length - 1
                    ].name = this.detail.subject;
                }
            }, this.errorHandler);
            this.loading = false;
        },
    },
    components: {
        Banner,
        Breadcrumb,
        Loader,
    },
    mixins: [coreMixin],
};
</script>

<style></style>
